import { ItemInfo } from "@/features/matches";
import { cn } from "@/shared/lib";

import type { DrillAsset } from "../../api/useDrillAssets";

const SLOT_BORDER = {
  weapon: cn("border-2 border-slot-weapon"),
  vitality: cn("border-2 border-slot-vitality"),
  spirit: cn("border-2 border-slot-spirit"),
} as const;

type AssetImageProps = {
  asset: DrillAsset;
  size?: number;
  className?: string;
  // Иконка внутри варианта ответа (сама кнопка): описание предмета по нажатию не показываем —
  // кнопка в кнопке не работает, а описание до ответа подсказало бы его.
  inOption?: boolean;
};

// Иконка предмета, героя или способности с явными размерами; у предмета рамка — цвет ветки
// магазина. Название всегда стоит рядом текстом, поэтому `alt` пустой. Иконки нет — первая
// буква названия. Иконка предмета вне вариантов ответа — кнопка с описанием предмета.
export const AssetImage = ({ asset, size = 44, className, inOption = false }: AssetImageProps) => {
  const classes = cn(
    "shrink-0 rounded-lg bg-surface-raised object-cover",
    asset.slot !== null && SLOT_BORDER[asset.slot],
    className,
  );
  if (asset.iconUrl === null) {
    return (
      <span
        aria-hidden="true"
        style={{ width: size, height: size }}
        className={cn(classes, "inline-flex items-center justify-center font-display text-muted")}
      >
        {asset.name.slice(0, 1)}
      </span>
    );
  }
  const image = (
    <img
      src={asset.iconUrl}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      style={{ width: size, height: size }}
      className={classes}
    />
  );
  return asset.itemId === null || inOption ? (
    image
  ) : (
    <ItemInfo itemId={asset.itemId} name={asset.name}>
      {image}
    </ItemInfo>
  );
};
